import LTR from "@brand-icons/global/lock-full-close/lock-full-close-ltr.svg";

import { iconFactory } from "../iconFactory";

export const LockFullCloseIcon = iconFactory("LockFullCloseIcon", LTR);
